import { render, staticRenderFns } from "./PopoverSelectedBadge.vue?vue&type=template&id=72ac5e84&scoped=true"
import script from "./PopoverSelectedBadge.vue?vue&type=script&lang=js"
export * from "./PopoverSelectedBadge.vue?vue&type=script&lang=js"
import style0 from "./PopoverSelectedBadge.vue?vue&type=style&index=0&id=72ac5e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac5e84",
  null
  
)

export default component.exports